(() => {
  'use strict';
  const paths = {
    '→': 'M3 12h18M15 6l6 6-6 6',
    '←': 'M21 12H3M9 6l-6 6 6 6',
    '↑': 'M12 21V3M6 9l6-6 6 6',
    '↓': 'M12 3v18M6 15l6 6 6-6',
    '↗': 'M5 19 19 5M5 5h14v14',
    '↘': 'M5 5l14 14M5 19h14V5',
    '↙': 'M19 5 5 19M5 5v14h14',
    '↖': 'M19 19 5 5M5 19V5h14',
    '↔': 'M3 12h18M8 7l-5 5 5 5M16 7l5 5-5 5',
    '↕': 'M12 3v18M7 8l5-5 5 5M7 16l5 5 5-5',
    '↩': 'M20 5v7H4M10 6l-6 6 6 6',
    '↪': 'M4 5v7h16M14 6l6 6-6 6',
    '⇄': 'M3 7h18M17 3l4 4-4 4M21 17H3M7 13l-4 4 4 4',
    '⇅': 'M7 21V3M3 7l4-4 4 4M17 3v18M13 17l4 4 4-4',
    '⤴': 'M3 19h12V4M9 10l6-6 6 6',
    '⤵': 'M3 5h12v15M9 14l6 6 6-6'
  };
  const aliases = { '➜':'→', '➝':'→', '➞':'→', '➟':'→', '➠':'→', '➡':'→', '⬅':'←', '⬆':'↑', '⬇':'↓', '⇆':'⇄', '⇵':'⇅' };
  const pattern = /[←↑→↓↖↗↘↙↔↕↩↪⇄⇆⇅⇵➜➝➞➟➠➡⬅⬆⬇⤴⤵][\uFE0E\uFE0F]?/g;
  const excluded = 'script,style,noscript,textarea,input,select,option,pre,code,svg,math,[contenteditable]:not([contenteditable="false"]),.obvs-text-arrow';
  const namespace = 'http://www.w3.org/2000/svg';

  function convert(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(excluded)) return;
    const text = node.nodeValue;
    const matches = [...text.matchAll(pattern)];
    if (!matches.length) return;
    const fragment = document.createDocumentFragment();
    let start = 0;
    for (const match of matches) {
      fragment.append(document.createTextNode(text.slice(start, match.index)));
      const character = match[0][0];
      const icon = document.createElement('span');
      icon.className = 'obvs-text-arrow';
      const svg = document.createElementNS(namespace, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const path = document.createElementNS(namespace, 'path');
      path.setAttribute('d', paths[aliases[character] || character]);
      svg.append(path);
      const accessibleText = document.createElement('span');
      accessibleText.className = 'obvs-arrow-text';
      accessibleText.textContent = match[0];
      icon.append(svg, accessibleText);
      fragment.append(icon);
      start = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(text.slice(start)));
    node.replaceWith(fragment);
  }

  function scan(root) {
    if (root.nodeType === 3) { convert(root); return; }
    if (root.nodeType !== 1 || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, 4);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(convert);
  }

  function start() {
    scan(document.body);
    new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target);
        else record.addedNodes.forEach(node => roots.add(node));
      }
      roots.forEach(root => { if (root.isConnected) scan(root); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
